import { isLogicGroup } from '../filterQueryFormat/logic/LogicGroup';
import { useInternalValue } from './useInternalValue';
export const useQuickFiltersInternalValue = (baseFilterFamily, strategy, quickFilters, data, fetchMore, getIsUngated, hasScope, isUserInfoFetched) => {
  const quickFiltersInOrGroupInternalValue = useInternalValue(baseFilterFamily, strategy, quickFilters, data, fetchMore, getIsUngated, hasScope, isUserInfoFetched);
  const firstCondition = quickFiltersInOrGroupInternalValue && quickFiltersInOrGroupInternalValue.conditions.first();
  if (isLogicGroup(firstCondition) && !firstCondition.conditions.isEmpty()) {
    return firstCondition;
  }
  return undefined;
};